export function htmlElementAsString(target) {
    if (!target) {
        return null;
    }
    var tagName = target.tagName.toLowerCase();
    if (tagName === 'body') {
        return null;
    }
    var classNames = target.classList.value;
    classNames = classNames !== '' ? " class=\"".concat(classNames, "\"") : '';
    var id = target.id ? " id=\"".concat(target.id, "\"") : '';
    var innerText = target.innerText;
    return "<".concat(tagName).concat(id).concat(classNames !== '' ? classNames : '', ">").concat(innerText, "</").concat(tagName, ">");
}
